import { render, staticRenderFns } from "./PurchasePolitics.vue?vue&type=template&id=3c2840e7&"
import script from "./PurchasePolitics.vue?vue&type=script&lang=js&"
export * from "./PurchasePolitics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports